import styled, { useTheme } from "styled-components/native";
import Constants from "expo-constants";
import Loader from "@components/atoms/Loader";
import { Platform } from "react-native";

const SplashScreen = ({ isVisible }: { isVisible: boolean }) => {
  const theme = useTheme();
  const splashMobile = require("../../../assets/splash.png");
  const splashTablet = require("../../../assets/splash-tablet.png");
  const backgroundColor =
    Constants.expoConfig?.splash?.backgroundColor || "transparent";

  return (
    <>
      {isVisible && (
        <Container backgroundColor={backgroundColor}>
          {Platform.OS === "web" ? (
            <Loader />
          ) : (
            <StyledImage
              resizeMode={"contain"}
              source={theme.isMobile ? splashMobile : splashTablet}
            />
          )}
        </Container>
      )}
    </>
  );
};

const Container = styled.View<{ backgroundColor: string }>`
  position: absolute;
  flex: 1;
  background-color: ${(props) => props.backgroundColor};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const StyledImage = styled.Image`
  width: 100%;
  height: 100%;
`;

export default SplashScreen;
